/** 搜索 **/
import { TYPE_ALL, MODE_LIST, CLASSIFY_A, HAS_PHONE, HAS_LINK_NAME } from "@/utils/constants/constants";
import { FILTER_TABS } from "@/utils/constants/constants.search";
import { buriedPointSearchKeyword } from "@/services/common/search";
import { DEFAULT_TAB_PARAM, DEFAULT_TAB_CHOSE_PARAM } from "@/utils/constants/constants.search-filter";

const search = {
  namespaced: true,
  state: {
    typeList: TYPE_ALL,
    modeList: MODE_LIST,
    hasPhone: HAS_PHONE,
    hasLinkName: HAS_LINK_NAME,
    initializationType: 1, //搜索条件初始化状态
    batchNo: "", // 埋点批次号，默认为空，第一次埋点发起后回调值为batchNo，后续使用
    searchParams: DEFAULT_TAB_PARAM[0],
    searchChoseParams: DEFAULT_TAB_CHOSE_PARAM[0],
    currentClassifyCategory: CLASSIFY_A, // 当前分类集合
    relatedSearch: [], // 相关搜索
    peerSearch: [], // 同行还在搜
    searchHistory: [], // 搜索历史
    currentFilterTab: FILTER_TABS[0],
    subscriptionSave: {
      show: false,
      type: 1,
    }, //1保存订阅，2订阅更新
    searchFilterClear: false,
    expandSearchKeywordsPackages: [], // 拓展搜索词 词包
    expandSearchKeywordsStr: "", // 拓展搜索词，命中的词组
    industryClassificationData: [], //行业分类数据，供给列表上方使用
  },
  getters: {
    batchNo: (state) => state.batchNo,
    searchParams: (state) => state.searchParams,
    searchChoseParams: (state) => state.searchChoseParams,
    typeList: (state) => state.typeList,
    hasPhone: (state) => state.hasPhone,
    hasLinkName: (state) => state.hasLinkName,
    currentClassifyCategory: (state) => state.currentClassifyCategory,
    relatedSearch: (state) => state.relatedSearch,
    peerSearch: (state) => state.peerSearch,
    searchHistory: (state) => state.searchHistory,
    currentFilterTab: (state) => state.currentFilterTab,
    initializationType: (state) => state.initializationType,
    subscriptionSave: (state) => state.subscriptionSave,
    searchFilterClear: (state) => state.searchFilterClear,
    expandSearchKeywordsPackages: (state) => state.expandSearchKeywordsPackages,
    expandSearchKeywordsStr: (state) => state.expandSearchKeywordsStr,
    industryClassificationData: (state) => state.industryClassificationData,
  },
  mutations: {
    //更新埋点批次号
    updateBatchNo(state, batchNo) {
      state.batchNo = batchNo;
    },
    //更新接口参数
    updateSearchParams(state, searchParams) {
      state.searchParams = {
        ...state.searchParams,
        ...searchParams,
      };
    },
    //替换全部参数
    replaceSearchParams(state, searchParams) {
      state.searchParams = searchParams;
    },
    //更新接口参数
    updateSearchChoseParams(state, searchChoseParams) {
      state.searchChoseParams = searchChoseParams;
    },
    // 更新信息类型
    updateTypeList(state, typeList) {
      state.typeList = typeList;
    },
    // 更新当前分类集合
    updateCurrentClassifyCategory(state, currentClassifyCategory) {
      state.currentClassifyCategory = currentClassifyCategory;
    },
    // 更新相关搜索
    updateRelatedSearch(state, relatedSearch) {
      state.relatedSearch = relatedSearch;
    },
    // 更新同行还在搜
    updatePeerSearch(state, peerSearch) {
      state.peerSearch = peerSearch;
    },
    // 更新搜索历史
    updateSearchHistory(state, searchHistory) {
      state.searchHistory = searchHistory;
    },
    // 更新currentFilterTab
    updateCurrentFilterTab(state, currentFilterTab) {
      if (
        Object.hasOwnProperty.call(currentFilterTab, "id") &&
        Object.hasOwnProperty.call(currentFilterTab, "name") &&
        Object.hasOwnProperty.call(currentFilterTab, "val") &&
        Object.hasOwnProperty.call(currentFilterTab, "label")
      ) {
        const { id, name, val, label } = currentFilterTab;
        state.currentFilterTab = {
          id,
          name,
          val,
          label,
        };
      } else {
        console.error("updateCurrentFilterTab 缺少必要参数");
      }
    },
    //更新联系方式
    updateHasPhone(state, hasPhone) {
      state.hasPhone = hasPhone;
    },
    //更新联系人
    updateHasLinkName(state, hasLinkName) {
      state.hasLinkName = hasLinkName;
    },
    //更新初始化状态
    updateInitializationType(state, initializationType) {
      state.initializationType = initializationType;
    },
    //更新保存订阅，订阅更新状态
    updateSubscriptionSave(state, subscriptionSave) {
      state.subscriptionSave = subscriptionSave;
    },
    //列表缺省需要清楚条件
    updateSearchFilterClear(state, searchFilterClear) {
      state.searchFilterClear = searchFilterClear;
    },
    // 拓展搜索词 词包
    updateExpandSearchKeywordsPackages(state, expandSearchKeywordsPackages) {
      state.expandSearchKeywordsPackages = expandSearchKeywordsPackages;
    },
    // 拓展搜索词 命中词组
    updateExpandSearchKeywordsStr(state, expandSearchKeywordsStr) {
      state.expandSearchKeywordsStr = expandSearchKeywordsStr;
    },
    // 更新行业分类数据
    updateIndustryClassificationData(state, industryClassificationData) {
      state.industryClassificationData = industryClassificationData;
    },
  },
  actions: {
    // 搜索参数变更埋点
    async actionSearchParamsTrack(store) {
      const batchNo = store.getters["batchNo"];
      const dengji = store.rootGetters["basic/userInfo"].memberLevel;
      const keywords = store.getters["searchParams"].keywords;
      const pageNum = store.getters["searchParams"].currentPage;
      const searchType = store.getters["searchParams"].searchDataType;
      const sortBy = store.getters["searchParams"].sortType;
      const userId = store.rootGetters["basic/userInfo"].userId;
      const res = await buriedPointSearchKeyword({
        batchNo,
        dengji,
        keywords,
        pageNum,
        searchType,
        sortBy,
        userId,
      });
      // 更新埋点批次号
      store.commit("updateBatchNo", res.data);
    },
  },
};
export default search;
